import { applyMiddleware, compose, createStore } from 'redux'
import { thunk } from 'redux-thunk';

import rootReducer from './reducer'

let middlewares = [thunk]

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middlewares))
)

export default store